<template>
  <el-autocomplete ref="ac"
    v-model="label"
    :fetch-suggestions="refresh"
    :placeholder="placeholder"
    :size="size"
    @select="select"
    @change="change"
    :valueKey="labelField"
  >
  </el-autocomplete>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "changeVal",
  },
  props: {
    value: [Number, String, Array],
    valueField: String,
    labelField: String,
    url: String,
    placeholder: String,
    size: String,
    extraParam: Object,
    searchKey: {
      type: String,
      default: 'numberOrName'
    },
    selFirst: Boolean,
  },
  data: function() {
    return {
      label: null,
      selItem: null,
    }
  },
  methods: {
    changeSelItem: function(item){
        this.selItem = item;
        if(item){
          this.$emit("changeVal", item[this.valueField]);
          this.$emit("change", item);
        }
        else{
          this.$emit("changeVal", null);
          this.$emit("change", null);
        }
    },
    changeLabel: function(val){
      this.label = val;
    },

    change: function(val){
      // if(this.$refs.ac.activated) return;

      if(!val){
        this.changeSelItem(null);
        return;
      }

      if(this.selItem){
        var preLabel = this.selItem[this.labelField];
        if(preLabel != val){
          this.changeLabel(preLabel);
        }
      }
      else{
        this.changeLabel(null);
      }
    },
    select: function (item) {
      this.changeSelItem(item);
    },
    refresh: function(query, cb) {
      var postData = { }
      postData[this.searchKey] = query
      Object.assign(postData, this.extraParam)

      return this.$httpPost(this.url, postData).then(res => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
        }
        var items = res.datalist || [];
        if(cb) cb(items);
        return items;
      })
    }
  },
  mounted: function () {
    if(this.selFirst){
      this.refresh().then(items=>{
          if (items && items.length > 0) {
            this.changeSelItem(items[0]);
          }
      })
    }
  },
  watch: {
  }
}
</script>

<style lang="less">
</style>
